
const getGuideId = ({isBranchGuide, guideType}) => {
  const isBusinessGuide = guideType === 'business';
  if(isBranchGuide && isBusinessGuide){
    return 172;
  }else if(isBranchGuide && !isBusinessGuide){
    return 171;
  }else if(!isBranchGuide && isBusinessGuide){
    return 173;
  }else {
    return 170;
  }
};

export default getGuideId;
